// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes style_scaleInOut__XMIt9 {
  0%, 100% {
    transform: scale(2.7);
  }
  50% {
    transform: scale(3.5);
  }
}

.style_documentAnimation__fId3j {
  margin-left: 8px;
  animation-name: style_scaleInOut__XMIt9;
  animation-duration: 2000ms;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}`, "",{"version":3,"sources":["webpack://./src/components/resource/form/style.module.css"],"names":[],"mappings":"AAAA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,gBAAgB;EAChB,uCAA0B;EAC1B,0BAA0B;EAC1B,mCAAmC;EACnC,iCAAiC;AACnC","sourcesContent":["@keyframes scaleInOut {\n  0%, 100% {\n    transform: scale(2.7);\n  }\n  50% {\n    transform: scale(3.5);\n  }\n}\n\n.documentAnimation {\n  margin-left: 8px;\n  animation-name: scaleInOut;\n  animation-duration: 2000ms;\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"documentAnimation": `style_documentAnimation__fId3j`,
	"scaleInOut": `style_scaleInOut__XMIt9`
};
export default ___CSS_LOADER_EXPORT___;
